import { Chip as MChip, ChipProps } from '@mui/material'

export const Chip: React.FC<ChipProps> = (props) => {
  return <MChip {...props} />
}
